import { buildNotificationsWebSocketUrlFromApiHost } from './environment.ws-url';

let baseurl = window.location.hostname;

const apiUrlHost = 'https://api.' + baseurl;
// const apiUrlHost = 'http://localhost:8000';

export const environment = {
  appVersion: require('../../package.json').version,
  production: true,
  apiUrlHost,
  notificationsWebSocketUrl: buildNotificationsWebSocketUrlFromApiHost(apiUrlHost),
  /**
   * Per-environment: set false if this deployment’s API does not expose WSS yet (nginx/ASGI).
   * Uses the same cookie session as REST when true.
   */
  notificationsWebSocketEnabled: true,
  useLocalAddressStore: false,
};

console.log('Using development environment:', environment.apiUrlHost);
